'use client'

import { mountVercelToolbar } from '@vercel/toolbar'
import { useEffect } from 'react'
import { isDev } from '~/constants/routing'
import { useIsBaseHubEmployee } from '~/hooks/use-is-basehub-employee'

export const Toolbar = () => {
  const isBaseHubEmployee = useIsBaseHubEmployee()

  useEffect(() => {
    if (isBaseHubEmployee || isDev) {
      // Returns a cleanup function to unmount the toolbar
      return mountVercelToolbar()
    }
  }, [isBaseHubEmployee])

  return <></>
}
